import React, { useEffect, useState, useRef } from "react";
import "../styles/DissolveTransition.css";

const CssDissolveTransition = ({
  currentImage,
  nextImage,
  isActive,
  onComplete,
}) => {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!isActive) return;

    // Clear any existing timers
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // Start with non-transitioning state
    setIsTransitioning(false);

    // Force browser to apply initial state before starting transition
    // This small delay ensures the CSS transition works properly
    const startTimer = setTimeout(() => {
      // Now start the transition
      setIsTransitioning(true);

      // Set a longer timeout to match our CSS transition duration (1.5s)
      timerRef.current = setTimeout(() => {
        // Notify parent that transition is complete
        if (onComplete) {
          onComplete();
        }
      }, 1500); // Match this to the CSS transition duration
    }, 50); // Short delay to ensure proper rendering

    return () => {
      clearTimeout(startTimer);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [isActive, onComplete]);

  if (!isActive) return null;

  return (
    <div className={`dissolve-effect ${isTransitioning ? "is-active" : ""}`}>
      <div className="dissolve-slide">
        <div
          className="dissolve-image"
          style={{
            backgroundImage: `url(${currentImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      </div>
      <div className="dissolve-slide">
        <div
          className="dissolve-image"
          style={{
            backgroundImage: `url(${nextImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      </div>
    </div>
  );
};

export default CssDissolveTransition;
